export default __webpack_public_path__ + "b83c4d588d6fd781707d0feb17920f6f.svg";